import React from 'react';
import { Button } from 'antd';
import { useConnectModal } from '@rainbow-me/rainbowkit';

interface ConnectWalletButtonProps {
  text?: string; // Customize button text
  style?: React.CSSProperties; // Custom styles
  disabled?: boolean; // Disable the button
  loading?: boolean; // Show loading spinner
}

const ConnectWalletButton: React.FC<ConnectWalletButtonProps> = ({
  text = 'Connect Wallet',
  style,
  disabled = false,
  loading = false,
}) => {
  const { openConnectModal } = useConnectModal();

  return (
    <Button
      type="primary"
      size="large"
      onClick={openConnectModal}
      disabled={disabled}
      loading={loading}
      style={{
        backgroundColor: '#1890ff',
        border: 'none',
        borderRadius: '8px',
        padding: '0.5rem 1rem',
        fontSize: '16px',
        ...style,
      }}
    >
      {text}
    </Button>
  );
};

export default ConnectWalletButton;
